import { render, staticRenderFns } from "./lead-register.vue?vue&type=template&id=1a4729af"
import script from "./lead-register.vue?vue&type=script&lang=js"
export * from "./lead-register.vue?vue&type=script&lang=js"
import style0 from "./lead-register.vue?vue&type=style&index=0&id=1a4729af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports